import React, { Component } from 'react'
import { AlphanumericInputWithMask } from '@lmig/lmds-react'

/*Date: 12/16/20
 Author: Scott Lynch, n1503744
 Recipient Name Component
*/

class RecipientName extends Component {
  state = {
    ht: 'error',
    val: undefined,
  }
  handleFormChange = event => {
    let inputValue = event.target.value
    if (inputValue.length > 0) {
      this.setState({ ht: undefined })
    } else {
      this.setState({ ht: 'error' })
    }
  }
  render() {
    const { onChangeValue } = this.props
    const regex = /^[^*|":<>[\]{}`\\;@$]+$/
    return (
      <div>
        <AlphanumericInputWithMask
          name='recipientName'
          highlightType={this.state.ht}
          id='Alphanumeric--recipientName'
          labelVisual='Recipient Name as it would appear on 1099'
          onChange={function (e) {
            onChangeValue(e)
            this.handleFormChange(e)
          }.bind(this)}
          mask={{mask: regex}}
        />
      </div>
    )
  }
}

export default RecipientName
